// 메뉴 vuex
const menuStore = {
  namespaced: true,

  state: {
    isMyInfo: {
      show: false
    },
    IsShow: {
      showClientManagement: false,
      showTestInformation: true,
      showMy: false
    }
  },

  getters: {
    getIsShow: state => state.IsShow,
    getClientManagement: state => state.IsShow.showClientManagement,
    getTestInformation: state => state.IsShow.showTestInformation,
    getMy: state => state.IsShow.showMy,
    getIsMyInfo: state => state.isMyInfo
  },

  mutations: {
    setClientManagement: (state, payload) => {
      state.IsShow.showClientManagement = payload
    },
    setTestInformation: (state, payload) => {
      state.IsShow.showTestInformation = payload
    },

    showClientManagement: (state) => {
      state.IsShow.showClientManagement = true
      state.IsShow.showTestInformation = false
      state.IsShow.showMy = false
    },

    showTestInformation: (state) => {
      state.IsShow.showClientManagement = false
      state.IsShow.showTestInformation = true
      state.IsShow.showMy = false
    },

    showMy: (state) => {
      state.IsShow.showClientManagement = false
      state.IsShow.showTestInformation = false
      state.IsShow.showMy = !state.IsShow.showMy
    },

    mutationIsMyInfo: (state, payload) => {
      state.isMyInfo.show = payload
    }
  }
}

export default menuStore
